import { render, staticRenderFns } from "./NewsAndInformation.vue?vue&type=template&id=89cafd80&"
import script from "./NewsAndInformation.vue?vue&type=script&lang=js&"
export * from "./NewsAndInformation.vue?vue&type=script&lang=js&"
import style0 from "./NewsAndInformation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports